import type { FC } from "react";

const { NAME, VERSION, COMMIT_HASH, LAST_COMMIT_DATETIME, BUILD_TIME } = APP_INFO;

export type AppVersionProps = Readonly<{}>;

/**
 * Displays information about application, like version and name from package.json and commit info.
 * Localization is not currently supported.
 */
export const AppVersion: FC<AppVersionProps> = () => (
    <div>
        <div>App name: {NAME}</div>
        <div>Version: {VERSION}</div>
        <div>Commit hash: {String(COMMIT_HASH).substring(0, 8)}</div>
        <div>Commit time: {LAST_COMMIT_DATETIME}</div>
        <div>Build time: {new Date(BUILD_TIME).toISOString()}</div>
    </div>
);
